import { useEffect, useState } from 'react';

let deferredPrompt = null;
const listeners = new Set();

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    listeners.forEach((fn) => fn());
  });
  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    localStorage.setItem('rs_pwa_installed', '1');
    listeners.forEach((fn) => fn());
  });
}

export const isStandalone = () =>
  window.matchMedia?.('(display-mode: standalone)').matches || window.navigator.standalone === true;

export const detectPlatform = () => {
  const ua = navigator.userAgent || '';
  if (/iphone|ipad|ipod/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) return 'ios';
  if (/android/i.test(ua)) return 'android';
  return 'desktop';
};

export const usePwaInstall = () => {
  const [, tick] = useState(0);
  useEffect(() => {
    const fn = () => tick((n) => n + 1);
    listeners.add(fn);
    return () => listeners.delete(fn);
  }, []);
  const installed = isStandalone();
  const promptInstall = async () => {
    if (!deferredPrompt) return 'unavailable';
    const ev = deferredPrompt;
    deferredPrompt = null;
    ev.prompt();
    const { outcome } = await ev.userChoice;
    listeners.forEach((fn) => fn());
    return outcome;
  };
  return { canPrompt: !!deferredPrompt, installed, promptInstall, platform: detectPlatform() };
};
